<template>
    <div class="container">
        <div class="sub-container">
            <div class="buy-container">
            <div class="title-container">
                <h2 v-if="title != ''">
                    Оставляйте заявку
                </h2>
            </div>
            <p class="text">
                для оформления заказа Системы контроля нагрева ленточного полотна
            </p>
            
            <button class="button" v-on:click="clicked = !clicked" >
                <svg width="26" height="26" viewBox="0 0 38 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-inside-1_5097_3143" fill="white">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.37891 0C1.55048 0 0.878906 0.671573 0.878906 1.5C0.878906 2.32843 1.55048 3 2.37891 3H7.46363C7.68273 3 7.8763 3.14264 7.9412 3.3519L9.14887 7.24609H8.30469L11.2045 21.0797C11.3623 21.8388 11.7946 22.5207 12.4257 23.006C13.0569 23.4913 13.8466 23.7491 14.6566 23.7343H31.4339C32.244 23.7491 33.0337 23.4913 33.6648 23.006C34.2959 22.5207 34.7282 21.8388 34.886 21.0797L37.6477 7.24609H12.2898L10.8066 2.46328C10.3523 0.998455 8.99728 0 7.46363 0H2.37891ZM19.079 28.7017C19.079 30.1775 17.8266 31.3739 16.2817 31.3739C14.7368 31.3739 13.4844 30.1775 13.4844 28.7017C13.4844 27.2259 14.7368 26.0295 16.2817 26.0295C17.8266 26.0295 19.079 27.2259 19.079 28.7017ZM33.5653 28.7017C33.5653 30.1775 32.3129 31.3739 30.768 31.3739C29.2231 31.3739 27.9707 30.1775 27.9707 28.7017C27.9707 27.2259 29.2231 26.0295 30.768 26.0295C32.3129 26.0295 33.5653 27.2259 33.5653 28.7017Z"/>
                    </mask>
                    <path d="M7.9412 3.3519L6.03095 3.94431L6.03095 3.94431L7.9412 3.3519ZM9.14887 7.24609V9.24609H11.8631L11.0591 6.65368L9.14887 7.24609ZM8.30469 7.24609V5.24609H5.84198L6.34723 7.65641L8.30469 7.24609ZM11.2045 21.0797L13.1626 20.6725L13.1619 20.6694L11.2045 21.0797ZM14.6566 23.7343V21.7343H14.6383L14.62 21.7346L14.6566 23.7343ZM31.4339 23.7343L31.4705 21.7346L31.4522 21.7343H31.4339V23.7343ZM33.6648 23.006L34.8839 24.5914L34.8839 24.5914L33.6648 23.006ZM34.886 21.0797L36.8442 21.4868L36.8458 21.479L36.8473 21.4712L34.886 21.0797ZM37.6477 7.24609L39.609 7.63764L40.0865 5.24609H37.6477V7.24609ZM12.2898 7.24609L10.3796 7.8385L10.8161 9.24609H12.2898V7.24609ZM10.8066 2.46328L12.7168 1.87087V1.87087L10.8066 2.46328ZM2.87891 1.5C2.87891 1.77614 2.65505 2 2.37891 2V-2C0.44591 -2 -1.12109 -0.432997 -1.12109 1.5H2.87891ZM2.37891 1C2.65505 1 2.87891 1.22386 2.87891 1.5H-1.12109C-1.12109 3.433 0.44591 5 2.37891 5V1ZM7.46363 1H2.37891V5H7.46363V1ZM9.85144 2.75949C9.52696 1.71318 8.5591 1 7.46363 1V5C6.80636 5 6.22564 4.57209 6.03095 3.94431L9.85144 2.75949ZM11.0591 6.65368L9.85144 2.75949L6.03095 3.94431L7.23862 7.8385L11.0591 6.65368ZM9.14887 5.24609H8.30469V9.24609H9.14887V5.24609ZM6.34723 7.65641L9.24701 21.49L13.1619 20.6694L10.2621 6.83577L6.34723 7.65641ZM9.24635 21.4868C9.50443 22.728 10.2072 23.823 11.2066 24.5914L13.6449 21.4206C13.382 21.2184 13.2202 20.9496 13.1626 20.6725L9.24635 21.4868ZM11.2066 24.5914C12.204 25.3585 13.4384 25.7569 14.6932 25.734L14.62 21.7346C14.2547 21.7413 13.9097 21.6242 13.6449 21.4206L11.2066 24.5914ZM14.6566 25.7343H31.4339V21.7343H14.6566V25.7343ZM31.3973 25.734C32.6521 25.7569 33.8865 25.3585 34.8839 24.5914L32.4456 21.4206C32.1809 21.6242 31.8358 21.7413 31.4705 21.7346L31.3973 25.734ZM34.8839 24.5914C35.8833 23.823 36.5861 22.728 36.8442 21.4868L32.9279 20.6725C32.8703 20.9496 32.7085 21.2184 32.4456 21.4206L34.8839 24.5914ZM36.8473 21.4712L39.609 7.63764L35.6864 6.85455L32.9247 20.6881L36.8473 21.4712ZM37.6477 5.24609H12.2898V9.24609H37.6477V5.24609ZM8.89632 3.05569L10.3796 7.8385L14.2001 6.65368L12.7168 1.87087L8.89632 3.05569ZM7.46363 2C8.12091 2 8.70163 2.42791 8.89632 3.05569L12.7168 1.87087C12.003 -0.430998 9.87365 -2 7.46363 -2V2ZM2.37891 2H7.46363V-2H2.37891V2ZM16.2817 33.3739C18.844 33.3739 21.079 31.3673 21.079 28.7017H17.079C17.079 28.9877 16.8093 29.3739 16.2817 29.3739V33.3739ZM11.4844 28.7017C11.4844 31.3673 13.7194 33.3739 16.2817 33.3739V29.3739C15.7541 29.3739 15.4844 28.9877 15.4844 28.7017H11.4844ZM16.2817 24.0295C13.7194 24.0295 11.4844 26.0361 11.4844 28.7017H15.4844C15.4844 28.4157 15.7541 28.0295 16.2817 28.0295V24.0295ZM21.079 28.7017C21.079 26.0361 18.844 24.0295 16.2817 24.0295V28.0295C16.8093 28.0295 17.079 28.4157 17.079 28.7017H21.079ZM30.768 33.3739C33.3303 33.3739 35.5653 31.3673 35.5653 28.7017H31.5653C31.5653 28.9877 31.2956 29.3739 30.768 29.3739V33.3739ZM25.9707 28.7017C25.9707 31.3673 28.2058 33.3739 30.768 33.3739V29.3739C30.2405 29.3739 29.9707 28.9877 29.9707 28.7017H25.9707ZM30.768 24.0295C28.2058 24.0295 25.9707 26.0361 25.9707 28.7017H29.9707C29.9707 28.4157 30.2405 28.0295 30.768 28.0295V24.0295ZM35.5653 28.7017C35.5653 26.0361 33.3303 24.0295 30.768 24.0295V28.0295C31.2956 28.0295 31.5653 28.4157 31.5653 28.7017H35.5653Z" fill="#1E70B6" mask="url(#path-1-inside-1_5097_3143)"/>
                </svg>



                {{ $t('Buttons.buy') }}
            </button>
            </div>
        </div>
        <Modal :clicked="clicked" :getClicked="getClickedParent" title="Система контроля нагрева ленточного полотна"/>

    </div>  
</template>

<script>
import Modal from "@/components/ui/Modal.vue"

export default {
  name: "ApplicationHeatingOfLenta",
  components: {Modal},
  data() {
    return {
        clicked: false
    }
  },

  methods: {
    getClickedParent(clicked) {
      this.clicked=clicked
    }
    
  },
  

}

</script>

<style scoped>

.container{
    background: var(--about-bg);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4vh 0;
}

.sub-container{
    display: flex;
    flex-direction: column;
    max-width: 1300px;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.text{
    font-size: clamp(14px, 1.8vh, 50px);
    text-align: center;
    color: var(--text);

}

.buy-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 2vh;
    width: 100%;

  }  

  h2{
    text-align: center;
    font-size: clamp(30px, 4.8vw, 50px);
    font-family: geometria_extralight;
    text-transform: uppercase;
    width: 100%;
    color: var(--text);
  }

  .button {
    width: 32vh;
    min-width: 250px;
    height: 48px;
    border-radius: 15px;
    font-size: clamp(15px, 1.8vh, 50px);
    color: #1E70B6;
    border: solid 1px #1E70B6;
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    column-gap: 1vh;
    text-transform: uppercase;
    font-family: Geometria_regular;
    cursor: pointer;
    transition: 0.3s;
    position: relative;
  }

  .button:hover {
    letter-spacing: 2px;
  }

@media (max-width: 1300px){


} 


@media (max-width: 800px){

} 

</style>